// Modules
import React from 'react'

// Sections
import Form from './sections/form/Form'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Landing.scss'

// View: Two-factor authentication > Landing
function Landing () {
	// Data
	// const { translate } = useLanguage('pages.twoFactorAuthentication.views.landing')

	// Render
	return (
		<Page.View name="landing">
			<Form />
		</Page.View>
	)
}

// Export
export default Landing
